globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.AddMediaImagesToFolder = (function(superClass) {

  utils.extend(AddMediaImagesToFolder, superClass);

  AddMediaImagesToFolder.ajaxResourcePath = "/configuration/mediatheque/folder_files";

  function AddMediaImagesToFolder() {
    AddMediaImagesToFolder.__super__.constructor.apply(this, arguments);

    this.$buttonUploader = this.$html.find('.add-files');
    this.$includedFilesContainer = this.$html.find('.included-files-container .files-items');
    this.$excludedFilesContainer = this.$html.find('.excluded-files-container .files-items');
  }

  $.extend(AddMediaImagesToFolder.prototype, {
    init: function() {
      var modal = this;

      modal._initUploader();
      modal._initSortable();
      modal._initEvents();
      SearchFilter.initFilters($('.search-filter'), {
        typingCallback: function(){
          console.log('type');
        }
      });

      return AddMediaImagesToFolder.__super__.init.apply(this, arguments);
    },
    _initEvents: function(){
      var modal = this;

      modal.$html.on('click', 'button.submit', function(){
        appCustomerSpace.Loader().start({$container: modal.$html.find('.modal-content')})
        location.reload();
      });

      modal.$includedFilesContainer.on('click', '.file-item', function(){
        var $folderFile = $(this);

        appCustomerSpace.Loader().start({ $container: $folderFile, options: {text: '', icon_size: '2x' } })

        modal._deleteFolderFile($folderFile, function(data){
          $folderFile.fadeOut(90, function(){
            $folderFile.remove();
            modal.$excludedFilesContainer.prepend($(data.html));
          });
        })
      });

      modal.$excludedFilesContainer.on('click', '.file-item', function(){
        var $mediaFile = $(this),
            file_uniq_key = $mediaFile.data('uniq-key');

        appCustomerSpace.Loader().start({ $container: $mediaFile, options: {text: '', icon_size: '2x' } })

        modal._createFolderFile(file_uniq_key, function(data){
          $mediaFile.fadeOut(90, function(){
            $mediaFile.remove();
            modal.$includedFilesContainer.prepend($(data.html));
          });
        })
      });
    },
    _initSortable: function(){
      var modal = this,
          options = {
            items: '> .file-item',
            helper: 'clone',
            containment: '.files-items',
            handle: '.btn-order',
            start : function(e, ui) {
              $('body').addClass('cursor-grabbing');
              ui.placeholder.css('visibility', 'visible').css('height', modal.$includedFilesContainer.find('.file-item')[0].getBoundingClientRect().height);
            },
            stop : function(e, ui) {
              $('body').removeClass('cursor-grabbing');

              $.post(AddMediaImagesToFolder.ajaxResourcePath + '/' + ui.item.data('id'), {
                _method: 'PATCH',
                accounts_folder_file: {
                  file_order_position: ui.item.index()
                }
              });
            }
          }

      modal.$includedFilesContainer.sortable(options);
    },
    _initUploader: function(){
      var _this = this;

      this.uploader = new Uploader(this.$html, {
        data : {},
        progress : {
          percent     : '.file-percent',
          progressbar : '.file-progressbar'
        },
        plupload : {
          drop_element  : this.$includedFilesContainer.closest('.thumbnails-container')[0],
          browse_button : this.$buttonUploader[0],
          url: '/configuration/mediatheque/images/upload'
        },
        callbacks : {
          filesAdded : function(up, files) {
            var files = Array.prototype.slice.call(files).reverse();

            for(var i = files.length - 1; i >= 0; i--) {
              _this._renderPreview(files[i]);
            }
          },
          uploadProgress : function(up, file) {
            var $preview = _this.$includedFilesContainer.find('#' + file.id),
                percent = file.percent + '%';

            $preview.find(this.config.progress.percent).text(percent).end()
                    .find(this.config.progress.progressbar).css('width', percent);
          },
          fileUploaded : function(up, file, response) {
            if(response.error) {
              _this.$includedFilesContainer.find('#' + file.id).addClass('error').find(this.config.progress.percent).text(response.error)
              setTimeout(function(){
                _this.$includedFilesContainer.find('#' + file.id).fadeOut(200, function() { $(this).remove() })
              }, 5000);
            } else {
              _this._createFolderFile(response.uniq_key, function(data) {
                _this.$includedFilesContainer.find('#' + file.id).replaceWith($(data.html));
              })
            }
          }
        }
      });
    },
    _renderPreview: function(image) {
      if(image) {
        var modal = this,
            preview = modal._$template().clone().attr('id', image.id),
            previewHeight = modal.$includedFilesContainer.find('.file-item').length ? modal.$includedFilesContainer.find('.file-item')[0].getBoundingClientRect().height : 120;
        preview.css('height', previewHeight);
        modal.$includedFilesContainer.prepend(preview.fadeIn(90));
      }
    },
    _createFolderFile: function(file_uniq_key, callback) {
      var modal = this,
          values = {
            folder_uniq_key: modal._getFolderUniqKey(),
            file_uniq_key: file_uniq_key
          }

      $.post(AddMediaImagesToFolder.ajaxResourcePath, values, function(data) {
        if(data.response == 1) callback.call(modal, data);
      }).fail(function() {
        console.log('Une erreur s\'est produite');
      });
    },
    _deleteFolderFile: function($folder_file, callback) {
      var modal = this;

      $.post(AddMediaImagesToFolder.ajaxResourcePath + '/' + $folder_file.data('id') + '.json', { _method: 'DELETE' }, function(data) {
        if(data.response == 1) callback.call(modal, data);
      }).fail(function() {
        console.log('Une erreur s\'est produite');
      });
    },
    _$template: function(){
      return $(this.$includedFilesContainer.find('template').html().trim());
    },
    _getFolderUniqKey: function(){
      return this.$html.data('folder-uniq-key')
    }
  });

  return AddMediaImagesToFolder;

})(appCustomerSpace.Modal);
